import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: 'https://eu.i.posthog.com',
  defaults: '2025-05-24',
  person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
  // Enable session recording
  session_recording: {
    recordCrossOriginIframes: true,
  },
  // Enable autocapture for automatic event tracking
  autocapture: true,
  // Capture pageviews automatically
  capture_pageview: true,
  // Capture performance metrics
  capture_performance: true,
  // Enable exception tracking
  capture_exceptions: true,
  // Debug mode for development
  debug: process.env.NODE_ENV === 'development',
  // Disable in development if you want
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') posthog.debug();
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <PostHogProvider apiKey="phc_kwx3PTe70SgACmt33HRtKkGMAmrThs0umsdCnUxxTRz" options={options}>
        <App />
      </PostHogProvider>
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();